require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberpullendorf-oberpullendorf.json") })
        }
      }, "path---betreuungseinrichtungen-oberpullendorf-oberpullendorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberpullendorf-oberpullendorf!./.cache/json/betreuungseinrichtungen-oberpullendorf-oberpullendorf.json
// module id = 988
// module chunks = 231608221292675